module.exports = __webpack_public_path__ + "static/media/xp-banner3.7beb1b08.jpg";